// DS: C59
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import DesktopSharePopup from './DesktopSharePopup';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle, getDeviationResourceType } from '../../DeviationViews/_helpers';
const DesktopDeviationSharePopup = ({ deviation })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(DesktopSharePopup, _object_spread({
        title: getTranslatedDeviationTitle(deviation, t),
        biData: {
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, getDeviationShareCodes(deviation)));
};
DesktopDeviationSharePopup.displayName = 'DesktopDeviationSharePopup';
export default DesktopDeviationSharePopup;

//# sourceMappingURL=DesktopDeviationSharePopup.js.map